import { IApplicationState } from '../../types/redux';

export const getEcologyRating = (state: IApplicationState): number | null => {
  return state.newReview.data.ecologyRating.value;
};
